import { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import LiveChatSupport from '../components/LiveChatSupport';
import { MessageCircle } from 'lucide-react';

const API = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) 
  ? 'http://localhost:8001/api' 
  : '/api';

const SupportPage = ({ user, setUser }) => {
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [whatsappEnabled, setWhatsappEnabled] = useState(false);
  const [showLiveChat, setShowLiveChat] = useState(false);

  useEffect(() => {
    const fetchWhatsappSettings = async () => {
      try {
        const response = await fetch(`${API}/public/support-settings`);
        if (response.ok) {
          const data = await response.json();
          setWhatsappNumber(data.whatsapp_number || '');
          setWhatsappEnabled(data.whatsapp_enabled || false);
        }
      } catch (err) {
        console.log('WhatsApp settings not available');
      }
    };
    fetchWhatsappSettings();
  }, []);

  const openWhatsApp = () => {
    if (whatsappNumber) {
      window.open(`https://wa.me/${whatsappNumber}`, '_blank');
    }
  };

  // If live chat is open, show full screen chat
  if (showLiveChat) {
    return (
      <div className="h-screen flex flex-col bg-gray-900 overflow-hidden">
        <Navbar user={user} setUser={setUser} />
        <div className="flex-1 overflow-hidden">
          <LiveChatSupport 
            user={user}
            onClose={() => setShowLiveChat(false)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900">
      <Navbar user={user} setUser={setUser} />
      
      <div className="max-w-2xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-white mb-6 text-center">Destek</h1>
        
        <div className="space-y-4">
          {/* Canlı Destek Butonu */}
          <button
            onClick={() => setShowLiveChat(true)}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-xl p-4 flex items-center gap-4 transition-all shadow-lg"
          >
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
              <MessageCircle size={24} />
            </div>
            <div className="text-left">
              <div className="font-bold text-lg">Canlı Destek</div>
              <div className="text-sm text-white/80">Anlık mesajlaşma ile destek alın</div>
            </div>
          </button>

          {/* WhatsApp Butonu - Sadece aktif ve numara varsa göster */}
          {whatsappEnabled && whatsappNumber && (
            <button
              onClick={openWhatsApp}
              className="w-full bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white rounded-xl p-4 flex items-center gap-4 transition-all shadow-lg"
            >
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </div>
              <div className="text-left">
                <div className="font-bold text-lg">WhatsApp Destek</div>
                <div className="text-sm text-white/80">WhatsApp üzerinden bize ulaşın</div>
              </div>
            </button>
          )}
        </div>

        {/* Bilgi Notu */}
        <div className="mt-8 bg-gray-800 rounded-xl p-4 text-center">
          <p className="text-gray-400 text-sm">
            Destek ekibimiz size en kısa sürede yardımcı olacaktır.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
